import React from 'react';
import {
  Text,
  Avatar,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
  makeStyles,
  tokens,
} from '@fluentui/react-components';
import { SignOut24Regular, Person24Regular } from '@fluentui/react-icons';
import { useMsal } from '@azure/msal-react';
import senacLogo from '../../assets/senac.png';

const useStyles = makeStyles({
  topBar: {
    height: '55px', // 48px + 15%
    backgroundColor: '#ffffff',
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: '24px',
    paddingRight: '24px',
    boxShadow: tokens.shadow2,
    zIndex: 90,
    position: 'relative',
  },
  logoImage: {
    height: '36px',
    width: 'auto',
    objectFit: 'contain',
  },
  title: {
    fontSize: tokens.fontSizeBase500,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
  },
  userSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  userInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  userName: {
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
  },
  userEmail: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
  },
  menuButton: {
    cursor: 'pointer',
  },
});

export const TopBar: React.FC = () => {
  const styles = useStyles();
  const { instance, accounts } = useMsal();

  const handleSignOut = () => {
    instance.logoutPopup({
      mainWindowRedirectUri: `${window.location.origin}/login`,
    }).catch((e) => {
      console.error('Logout failed:', e);
    });
  };

  // Get user info from MSAL account
  const account = accounts[0];
  const user = {
    name: account?.name || 'User',
    email: account?.username || '',
    initials: account?.name
      ? account.name.split(' ').map((n) => n[0]).join('').substring(0, 2).toUpperCase()
      : 'U',
  };

  return (
    <div className={styles.topBar}>
      <img src={senacLogo} alt="Senac Logo" className={styles.logoImage} />
      <Text className={styles.title}>Senac School Data Sync Monitor 2.0</Text>
      <div className={styles.userSection}>
        <div className={styles.userInfo}>
          <Text className={styles.userName}>{user.name}</Text>
          <Text className={styles.userEmail}>{user.email}</Text>
        </div>
        <Menu>
          <MenuTrigger>
            <div className={styles.menuButton}>
              <Avatar
                name={user.name}
                initials={user.initials}
                size={32}
                color="colorful"
              />
            </div>
          </MenuTrigger>
          <MenuPopover>
            <MenuList>
              <MenuItem icon={<Person24Regular />}>Profile</MenuItem>
              <MenuItem icon={<SignOut24Regular />} onClick={handleSignOut}>
                Sign Out
              </MenuItem>
            </MenuList>
          </MenuPopover>
        </Menu>
      </div>
    </div>
  );
};

export default TopBar;
